import { render, staticRenderFns } from "./FollowupsPageShell.vue?vue&type=template&id=0dace4b6&scoped=true"
import script from "./FollowupsPageShell.vue?vue&type=script&lang=js"
export * from "./FollowupsPageShell.vue?vue&type=script&lang=js"
import style0 from "./FollowupsPageShell.vue?vue&type=style&index=0&id=0dace4b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dace4b6",
  null
  
)

export default component.exports